var _defs, _g, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutHeroBtnBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 70,
    viewBox: "0 0 274 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "btn-pink-bg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n            #btn-pink-bg:hover #btn-pink-bg-path-1 {\n                fill: #f7aced;\n            }\n\n            #btn-pink-bg:hover #btn-pink-bg-path-2 {\n                fill: url(#paint0_radial_325_2652);\n                fill-opacity: 1;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_388_683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "btn-pink-bg-path-1",
    d: "M0 64V27.4074C0 26.0878 0.435021 24.805 1.23771 23.7576L17.644 2.35026C18.7794 0.86872 20.5397 0 22.4063 0H268C271.314 0 274 2.68629 274 6V44.5858C274 45.9938 273.505 47.3569 272.601 48.4366L256.354 67.8508C255.214 69.213 253.529 70 251.752 70H6C2.68629 70 0 67.3137 0 64Z",
    fill: "#E9ABE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "btn-pink-bg-path-1",
    d: "M0 64V27.4074C0 26.0878 0.435021 24.805 1.23771 23.7576L17.644 2.35026C18.7794 0.86872 20.5397 0 22.4063 0H268C271.314 0 274 2.68629 274 6V44.5858C274 45.9938 273.505 47.3569 272.601 48.4366L256.354 67.8508C255.214 69.213 253.529 70 251.752 70H6C2.68629 70 0 67.3137 0 64Z",
    fill: "url(#paint0_radial_388_683)",
    fillOpacity: 0.6
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_388_683",
    x: 0,
    y: 0,
    width: 274,
    height: 74.9369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.93694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.17117
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.845833 0 0 0 0 0.965188 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_388_683"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_388_683",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137 35) rotate(100.591) scale(80.5833 315.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9ABE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_325_2652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141 26) rotate(118.701) scale(228.014 892.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9ABE1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutHeroBtnBg);
export default __webpack_public_path__ + "static/media/about-hero-btn-bg.75370053a834f0babe8df40a9fa10e9d.svg";
export { ForwardRef as ReactComponent };